import { assert, assertString } from '@Utils/assert';

import {
  updateOptionType,
  toggleRadioOptionType,
  fetchInitialOptionsType,
  toggleCheckboxOptionType,
  createInitialOptionsCopyType,
  updateSavedInfoWithCurrentType,
  setCurrentOptionsSameAsSavedType,
} from './StructureOptionsConstants';

import { fetchRawStructureOptions, normalizeFetchStructureOptions } from './StructureOptionsService';

export function fetchInitialOptions(context) {
  assertString(context, 'context, probably "all" has to be used as parameter');

  return async (dispatch) => {
    const rawStructureOptions = await fetchRawStructureOptions(context);

    dispatch({
      type: fetchInitialOptionsType,
      payload: rawStructureOptions,
    });

    return rawStructureOptions;
  };
}

export function createInitialOptionsCopy(id, normalizedOptions) {
  return {
    type: createInitialOptionsCopyType,
    payload: {
      id,
      normalizedOptions,
    },
  };
}

export function fetchAndCreateInitialOptionsCopy(id, customPredefinedOptions) {
  assert(id !== 'initialOptions', '"id" for initial options copy has to differ "initialOptions"');
  assertString(id, 'id');

  return async (dispatch) => {
    const initialOptions = await dispatch(fetchInitialOptions('all'));

    const normalizedOptions = normalizeFetchStructureOptions(initialOptions, customPredefinedOptions);

    dispatch(createInitialOptionsCopy(id, normalizedOptions));
  };
}

export function setCurrentOptionsSameAsSaved(id) {
  return {
    type: setCurrentOptionsSameAsSavedType,
    payload: {
      id,
    },
  };
}

export function updateOption(path, data) {
  return {
    type: updateOptionType,
    payload: {
      path,
      data,
    },
  };
}

export function updateInputValue(id, groupId, optionId, value) {
  return updateOption([id, 'current', 'groups', groupId, 'options', optionId], { inputValue: value });
}

export function toggleRadioOptionByPath(path, optionId) {
  return {
    type: toggleRadioOptionType,
    payload: {
      path,
      optionId,
    },
  };
}

export function toggleRadioOption(id, groupId, optionId) {
  return toggleRadioOptionByPath([id, 'current', 'groups', groupId, 'options'], optionId);
}

export function toggleSubRadioOption(id, groupId, optionId, subOptionId) {
  return toggleRadioOptionByPath([id, 'current', 'groups', groupId, 'options', optionId, 'subOptions'], subOptionId);
}

export function toggleCheckboxOption(id, groupId, optionId) {
  return {
    type: toggleCheckboxOptionType,
    payload: {
      path: [id, 'current', 'groups', groupId, 'options', optionId],
    },
  };
}

export function updateSavedInfoWithCurrent(id) {
  return {
    type: updateSavedInfoWithCurrentType,
    payload: { id },
  };
}
